import React, { useContext, useEffect } from 'react';
import proptypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';
import { CompatibleAccessoriesComponent, CompatibleAccessoriesProvider } from './components';
import { FS_MAPPING } from './constants';

const { string, func, bool } = proptypes;

export const CompatibleAccessories = ({
  itemId, parent, handleChecked, fsOverride, lineItemId, matchIdsForCheckbox
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('compatible-accessories.ready'); }, []);

  const { defaultVariables } = useContext(QueryContext) || {};

  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  const showComponent = ((useConfigService(FS_MAPPING[parent]) || false) || fsOverride) && (!!itemId && !!parent);

  if (!showComponent) {
    return null;
  }

  return (
    <QueryProvider defaultVariables={newDefaultVariables} cacheKey="compatible-accessories">
      <CompatibleAccessoriesProvider
        itemId={itemId}
        parent={parent}
        handleChecked={handleChecked}
        lineItemId={lineItemId}
        matchIdsForCheckbox={matchIdsForCheckbox}
      >
        <CompatibleAccessoriesComponent />
      </CompatibleAccessoriesProvider>
    </QueryProvider>
  );
};

CompatibleAccessories.propTypes = {
  itemId: string.isRequired,
  parent: string.isRequired,
  lineItemId: string,
  matchIdsForCheckbox: bool,
  handleChecked: func,
  fsOverride: bool
};

CompatibleAccessories.defaultProps = {
  handleChecked: null,
  fsOverride: false,
  lineItemId: '',
  matchIdsForCheckbox: false
};

CompatibleAccessories.dataModel = CompatibleAccessoriesProvider.dataModel;

CompatibleAccessories.displayName = 'CompatibleAccessories';
